import { useEffect, useRef } from "react";

export interface SafeRenderProps {
  render?: any;
}

const defaultRender = `function() {
  const div = document.createElement('div');
  div.innerHTML = '<h3 style="color:#ffd166">你好，世界!</h3>';
  return div;
}`;

// 安全执行函数
const executeFunction = (functionString: string, targetDom: any) => {
  try {
    // 创建安全沙箱环境
    const safeEnv = {
      document: {
        createElement: function (tagName: string) {
          return document.createElement(tagName);
        },
        createTextNode: function (text: string) {
          return document.createTextNode(text);
        },
      },
      console: {
        log: console.log,
        warn: console.warn,
        error: console.error,
      },
      // 限制访问的API
      alert: alert,
      Date: Date,
      Math: Math,
      JSON: JSON,
      // 阻止访问全局作用域
      window: undefined,
      globalThis: undefined,
      fetch: undefined,
      localStorage: undefined,
      sessionStorage: undefined,
      XMLHttpRequest: undefined,
      eval: undefined,
      Function: undefined,
    };

    // 创建函数
    const dynamicFunction = new Function(
      "sandbox",
      `with(sandbox) { 
              return (${functionString})(); 
          }`
    );

    // 执行函数
    const result = dynamicFunction(safeEnv);

    // 显示结果
    targetDom.innerHTML = "";

    if (result instanceof Node) {
      targetDom.appendChild(result);
    } else if (typeof result === "string") {
      targetDom.innerHTML = result;
    } else {
      targetDom.innerHTML = `<pre>${JSON.stringify(result, null, 2)}</pre>`;
    }
    // return targetDom;
  } catch (error) {
    console.error("执行错误:", error);
  }
};

/**
 * 自定义渲染组件
 * @returns 渲染函数
 */
const SafeRender = (props: SafeRenderProps) => {
  const safeEnvRef = useRef<HTMLDivElement>(null);
  const { render = defaultRender } = props;

  useEffect(() => {
    executeFunction(render, safeEnvRef.current);
  }, [render]);

  return <div ref={safeEnvRef}></div>;
};

export default SafeRender;
